/**
 * Page View Tracker Component
 * Automatically tracks page views when routes change
 * Handles GTM initialization timing automatically
 * Captures UTM params (first touch + last touch) on each navigation.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import gtmTracker from '@/utils/gtmTracker'
import { captureUtmFromUrl } from '@/utils/trackingSpine'
import { isYouthPath } from '@/config/youthEnvironment'

const PageViewTracker = () => {
  const location = useLocation()

  useEffect(() => {
    captureUtmFromUrl()
  }, [location.pathname, location.search])

  useEffect(() => {
    if (isYouthPath(location.pathname)) return undefined

    // Small delay to ensure route change is complete
    const timeoutId = setTimeout(() => {
      const pagePath = location.pathname
      const pageTitle = document.title || pagePath
      const pageLocation = window.location.href

      // Extract page name from path for better tracking
      const pageName = pagePath.split('/').filter(Boolean).pop() || 'home'
      const contentGroup = pagePath.split('/').filter(Boolean)[0] || 'home'

      // trackPageView now handles GTM initialization timing internally
      // It will queue the page view if GTM isn't ready yet
      gtmTracker.trackPageView({
        page_title: pageTitle,
        page_location: pageLocation,
        page_path: pagePath,
        page_name: pageName,
        content_group: contentGroup
      })
    }, 100)

    return () => clearTimeout(timeoutId)
  }, [location])

  return null
}

export default PageViewTracker
